<template>
  <a-config-provider :locale="lang">
    <div id="app">
      <router-view/>
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import enUS from 'ant-design-vue/lib/locale-provider/en_US'
import moment from 'moment'
import 'moment/locale/zh-cn'

moment.locale('zh_cn')
export default {
  computed: {
    lang() {
      return this.$store.state.lang === 'en' ? enUS : zhCN
    }
  }
}
</script>

<style lang="less">
  body {
    transform: translate3d(0, 0, 0);
  }
  html, body, #app{
    width: 100%;
    height: 100%;
    margin: 0;
    box-sizing: border-box;
    font-size: 16px;
    background-color: #f0f1f5;
    overflow-x: hidden;
    overflow-y: hidden;
  }
  .ant-checkbox-wrapper {
    margin-left: 0 !important;
    margin-bottom: 10px !important;
  }
  .amap-logo {
    display: none !important;
  }
  .amap-copyright {
    display: none !important;
  }
  .ant-layout {
    background-color: #fff !important;
  }
  .ant-layout-header {
    height: 68px !important;
  }
  .ant-menu-item {
    padding-top: 0;
  }
  .dataStatistics .el-range-editor .el-range-input {
    background-color: #2F3D4F;
    color: #EDFAFF;
  }
  .dataStatistics .el-date-editor .el-range-separator {
    color: #EDFAFF;
  }
  .dataStatistics .el-range-editor .el-picker-panel__content {
    background-color: #2F3D4F;
  }
  .ant-menu-dark {
    overflow: auto;
  }
  .ant-menu-dark::-webkit-scrollbar {
    width: 8px;
    // background-color: #ccc;
    border-radius: 4px;
  }
  .ant-menu-dark::-webkit-scrollbar-track {
    width: 8px;
    // background-color: #ccc;
    border-radius: 4px;
  }
  .ant-menu-dark::-webkit-scrollbar-thumb {
    width: 8px;
    background-color: #4961A3;
    border-radius: 4px;
  }
  .dateController .el-input--prefix .el-input__inner {
    outline: none;
    background-color: #2F3D4F;
    height: 32px;
    color: #CBCFC7;
    border: 1px solid #4E5A69;
  }
  .dataStatistics .dateController .el-date-editor .el-range__icon {
    margin-top: -5px;
  }
  // .statistics .el-input__inner {
  //   height: 32px;
  //   background-color: unset;
  //   color: #fff;
  // }
  .statistic .mask .ant-select-selection--multiple > ul > li, .statistic .ant-select-selection--multiple .ant-select-selection__rendered > ul > li {
    height: 32px !important;
    line-height: 32px !important;
  }
  .dataStatistics .el-date-editor .el-range__icon {
    position: absolute;
    top: 8px;
  }
  .dataStatistics .el-range-editor .el-range-input,
  .statistic  .el-range-editor .el-range-input {
    background-color: unset;
    color: #fff;
  }
  .statistic .el-date-editor .el-range-separator,
  .dataStatistics .el-date-editor .el-range-separator {
    color: #fff;
  }
  .statistics .el-date-editor .el-range-separator,
  .dataStatistics .el-date-editor .el-range-separator {
    line-height: 20px;
  }
  .statistics .el-date-editor .el-range__icon {
    top: 4px;
  }
  .time_wrapper .el-input__icon {
    line-height: 32px !important;
  }
  .warning .ant-form-item {
    margin-bottom: 24px;
  }
  .wraning .ant-input {
    color: #fff !important;
  }
  .warning .ant-calendar-picker-input.ant-input,
  .warning .ant-select-selection--single,
  .warning .ant-input-number-input,
  .statistics .ant-calendar-picker-input.ant-input,
  .statistics .ant-select-selection--multiple,
  .statistics .ant-input-number-inpu {
    background-color: #2F3D4F;
  }
  .statistics .ant-time-picker-input {
    background-color: unset;
    color: #fff;
    margin-left: 15px;
  }
  .statistics .anticon.anticon-clock-circle.ant-time-picker-clock-icon {
    color: #fff;
  }
  .statistic .ant-select-selection {
    background-color: #2F3D4F;
  }
  .statistic .ant-select-selection-selected-value {
    color: #fff;
  }
  .warning .ant-form-item-label > label {
    color: #bfbfbf;
  }
  .warning .ant-checkbox-wrapper {
    color: #bfbfbf;
  }
  .warning .ant-radio-wrapper {
    color: #bfbfbf;
  }
  .warning .ant-form-item-control::before,
  .warning .ant-form-item-control::after {
    display: inline;
  }
  .warning .ant-col-offset-4 {
    margin-left: 0;
  }
  .warning .ant-btn {
    padding: 0 15px;
  }
  .warning .ant-select-selection-selected-value {
    color: #fff
  }
  .warning .ant-input-number-input {
    color: #bfbfbf
  }
  .warning .ant-input-number-handler {
    background-color: #2F3D4F;
  }
  .warning .ant-input-number-handler-wrap .ant-input-number-handler .ant-input-number-handler-up-inner,
  .warning .ant-input-number-handler-wrap .ant-input-number-handler .ant-input-number-handler-down-inner {
    color: #fff;
  }
  .dataStatistics .el-icon-date:before {
    content: "\e78e";
    position: absolute;
    top: -5px;
    left: 6px;
  }
  .dataStatistics .el-icon-date:before {
    content: "\e78e";
    position: absolute;
    top: -4px;
    left: 6px;
  }
  .dataStatistics .mask.range .el-icon-date:before {
    top: -8px;
  }
  .ant-select-arrow .ant-select-arrow-icon {
    color: #fff;
  }
  .selectOption {
    background-color: #485464 !important;

    /deep/ .ant-empty-description {
      color: #fff;
    }
  }

  .aggregate {
    .aggregate_selectOption {
      background-color: #485464 !important;

      /deep/ .ant-empty-description {
        color: #fff;
      }
      .ant-select-dropdown-menu-item {
        height: 32px;
        line-height: 32px;
        padding: 0 12px;
        color: #fff;
        &.ant-select-dropdown-menu-item-selected {
          background-color: #485464;
          color: #fff;
        }
        &.ant-select-dropdown-menu-item-selected:hover {
          background-color: #485464;
          color: #fff;
        }
        &.ant-select-dropdown-menu-item-active {
          background-color: #A7ADB5;
          color: #333;
        }
        &:hover {
          background-color: #A7ADB5;
          color: #333;
        }
        &:nth-child(1) {
          color: transparent;
        }
      }
    }
  }
  .selectOption .ant-select-dropdown-menu-item {
    color: #fff !important;
  }
  .selectOption .ant-select-dropdown-menu-item.ant-select-dropdown-menu-item-selected {
    background-color: #485464 !important;
    color: #fff !important;
  }
  .selectOption .ant-select-dropdown-menu-item.ant-select-dropdown-menu-item-selected:hover {
    color: #333 !important;
  }
  .selectOption .ant-select-dropdown-menu-item.ant-select-dropdown-menu-item-active {
    background-color: #A7ADB5 !important;
    color: #333 !important;
  }
  .selectOption .ant-select-dropdown-menu-item:hover {
    background-color: #A7ADB5 !important;
    color: #333 !important;
  }
  .warningTagOption .ant-select-dropdown-menu-item:first-of-type {
    color: transparent !important;
  }
  .warningTagOption .ant-select-dropdown-menu-item {
    height: 32px !important;
    line-height: 32px !important;
    padding: 0 12px;
  }
  .tableWarningTagOption .ant-select-dropdown-menu-item:nth-child(2) {
    color: transparent !important;
  }
  .tableWarningTagOption .ant-select-dropdown-menu-item {
    height: 32px !important;
    line-height: 32px !important;
    padding: 0 12px;
  }
  // .ant-select-dropdown-menu-item.ant-select-dropdown-menu-item-active.ant-select-dropdown-menu-item-selected {
  //   background-color: #A7ADB5 !important;
  //   color: #fff !important;
  // }
  .ant-table-tbody .ant-table-column-has-filters p {
    // box-sizing: border-box;
    // padding-top: 15px;
    display: table-cell;
  }
  .preview #preview .konvajs-content {
    background: url(./assets/up.png) no-repeat 0 0 /contain;
  }
.overlay {
  padding: 0;
}
.overlay .ant-popover-inner {
  height: 50%;
  padding: 8px;
}
.chart-inner-bg {
  height: 100%;
  border-radius: 7%/4%;
  background-color:rgba(19, 25, 47, 0.9);
}
.dv-capsule-chart .unit-label {
  visibility: hidden;
}
.dv-capsule-chart .label-column {
  font-size: .1458rem !important;
}
.MaintainList .ant-table-small.ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body {
  max-height: 829px !important;
}
.warnings .ant-table-thead > tr > th .ant-table-column-sorter {
  vertical-align: top;
}
.wraning .ant-pagination-prev .ant-pagination-item-link,
.warning .ant-pagination-next .ant-pagination-item-link {
  background-color: unset !important;
  color: #fff !important;
}
.warning .ant-pagination-item {
  background-color: unset !important;
}
.warning .ant-pagination-item a {
  color: #fff !important;
}
.warning i.anticon.anticon-clock-circle.ant-time-picker-clock-icon {
  color: #fff !important;
}
.warning input.ant-time-picker-input {
  color: #fff;
  background-color: unset;
}
.warning .ant-select-selection {
  background-color: unset;
}
.ant-modal-body .ant-table-tbody > tr > td {
  padding: 8px 16px !important;
}
.MaintainList .ant-layout.ant-layout-has-sider > .ant-layout, .ant-layout.ant-layout-has-sider > .ant-layout-content {
  overflow: hidden !important;
}
.el-table th.el-table__cell {
  user-select: initial;
}
.confirmModal {
  .ant-modal-close {
    display: none !important;
  }
}
.ant-modal div[aria-hidden="true"] {
  display: none !important;
}
</style>
